var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"imageList",staticClass:"image-list"},_vm._l((_vm.urlList),function(url,index){return _c('y-image',_vm._b({key:index,staticClass:"image-item",attrs:{"url-list":_vm.urlList,"src":url}},'y-image',_vm.$attrs,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }